var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme2-home"},[_c('theme2-home-card'),_c('theme2-section1'),_c('theme2-section3'),_c('theme2-section4'),_c('theme2-section2'),_c('theme2-faq'),_c('theme-changer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }